module.exports = __webpack_public_path__ + "img/cnd_Focus.fdb1c8df.svg";